import { slugify } from '@garnish/forms';
import { type RadarPrediction } from '@garnish/location';

// ─────────────────────────────────────────────────────────────────────────────

export function getRadarPredictionId(prediction: RadarPrediction) {
  const { formattedAddress, latitude, longitude, layer } = prediction;

  return `${slugify(formattedAddress)}-${latitude}-${longitude}-${layer}`;
}
